import { useEffect } from "react";

export const useIntegratorFonts = (integratorTheme) => {
  useEffect(() => {
    if (!integratorTheme) return;

    // Get font information from theme
    const fontName = integratorTheme?.website_font_family || 'Inter';
    const fontUrl = integratorTheme?.website_font_url || 'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap';

    // Load the font from Google Fonts
    loadFontCSS(fontName, fontUrl);

    // Apply the font globally via CSS variable
    applyGlobalFont(fontName);

    // IMPORTANT: Also override the actual font classes directly
    updateFontClassStyles(fontName);

  }, [integratorTheme]);

  /**
   * Load font from Google Fonts
   */
  const loadFontCSS = (fontName, fontUrl) => {
    // Remove any previous dynamic font link
    const existingLink = document.querySelector('link[data-dynamic-font]');
    if (existingLink) {
      existingLink.remove();
    }

    // Create new link element for Google Fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontUrl;
    link.setAttribute('data-dynamic-font', 'true');

    // Add to document head
    document.head.appendChild(link);
  };

  /**
   * Apply font globally via CSS variable
   */
  const applyGlobalFont = (fontName) => {
    // Set CSS variable that all font classes will use
    document.documentElement.style.setProperty('--primary-font', `"${fontName}", sans-serif`);
  };

  /**
   * Directly override the font-family property for all font classes
   * This is necessary if your CSS classes aren't using the CSS variable
   */
  const updateFontClassStyles = (fontName) => {
    // Create a style element
    const style = document.createElement('style');
    style.setAttribute('id', 'dynamic-font-styles');

    // Remove any existing style element
    const existingStyle = document.getElementById('dynamic-font-styles');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Create CSS content that overrides all font classes
    const cssContent = `
      .font-Inter, .font-DM-Sans, .font-Inter-Tight {
        font-family: "${fontName}", sans-serif !important;
      }
    `;

    // Add the styles to the style element
    style.textContent = cssContent;

    // Add to document head
    document.head.appendChild(style);
  };
};